export default __webpack_public_path__ + "static/media/checkbox-checked.17ef5595.png";